import getRecentPeriod from "./get-recent-period";

export default function getRecentSeason(seasons, { state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  return getRecentPeriod(seasons);
}
